// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FeatureFlagItem-module__font-s-10___lXWq5 {
  font-size: 10px !important;
}

.FeatureFlagItem-module__font-s-12___ARyJV {
  font-size: 12px !important;
}

.FeatureFlagItem-module__font-s-13___jcawV {
  font-size: 13px !important;
}

.FeatureFlagItem-module__font-s-14___wXrMc {
  font-size: 14px !important;
}

.FeatureFlagItem-module__font-s-15___NN5Gi {
  font-size: 15px !important;
}

.FeatureFlagItem-module__font-s-16___DqF2L {
  font-size: 16px !important;
}

.FeatureFlagItem-module__font-s-18___UL4KT {
  font-size: 18px !important;
}

.FeatureFlagItem-module__font-s-20___pdS4v {
  font-size: 20px !important;
}

.FeatureFlagItem-module__font-s-22___Fog9s {
  font-size: 22px !important;
}

.FeatureFlagItem-module__font-s-28___Mr_CP {
  font-size: 28px !important;
}

.FeatureFlagItem-module__font-w-400___RSaQU {
  font-weight: 400 !important;
}

.FeatureFlagItem-module__font-w-500___zsiSW {
  font-weight: 500 !important;
}

.FeatureFlagItem-module__font-w-600___bXqoP {
  font-weight: 600 !important;
}

.FeatureFlagItem-module__font-w-700___h5xEz {
  font-weight: 700 !important;
}

.FeatureFlagItem-module__p-5___kWruT {
  padding: 5px !important;
}

.FeatureFlagItem-module__p-12___Ed_mg {
  padding: 12px !important;
}

.FeatureFlagItem-module__p-16___feXoY {
  padding: 16px !important;
}

.FeatureFlagItem-module__p-30___LGcwl {
  padding: 30px !important;
}

.FeatureFlagItem-module__p-b-0___ACpq9 {
  padding-bottom: 0 !important;
}

.FeatureFlagItem-module__p-b-5___lo5hJ {
  padding-bottom: 5px !important;
}

.FeatureFlagItem-module__p-b-10___bkSR4 {
  padding-bottom: 10px !important;
}

.FeatureFlagItem-module__p-b-12___qMZed {
  padding-bottom: 12px !important;
}

.FeatureFlagItem-module__p-b-16___Jx1N1 {
  padding-bottom: 16px !important;
}

.FeatureFlagItem-module__p-b-18___fxUGS {
  padding-bottom: 18px !important;
}

.FeatureFlagItem-module__p-b-20___otmO2 {
  padding-bottom: 20px !important;
}

.FeatureFlagItem-module__p-b-25___Hkdyt {
  padding-bottom: 25px !important;
}

.FeatureFlagItem-module__p-b-30___LzaiC {
  padding-bottom: 30px !important;
}

.FeatureFlagItem-module__p-b-50___ZMO5_ {
  padding-bottom: 50px !important;
}

.FeatureFlagItem-module__p-t-0___cS3H7 {
  padding-top: 0 !important;
}

.FeatureFlagItem-module__p-t-12___L_2hx {
  padding-top: 12px !important;
}

.FeatureFlagItem-module__p-t-16___OiGKU {
  padding-top: 16px !important;
}

.FeatureFlagItem-module__p-t-18___PWO4H {
  padding-top: 18px !important;
}

.FeatureFlagItem-module__p-t-20___G7gYW {
  padding-top: 20px !important;
}

.FeatureFlagItem-module__p-t-30___XvgQo {
  padding-top: 30px !important;
}

.FeatureFlagItem-module__p-t-40___HaBRy {
  padding-top: 40px !important;
}

.FeatureFlagItem-module__p-t-50____wZzS {
  padding-top: 50px !important;
}

.FeatureFlagItem-module__p-l-20___mVMQ4 {
  padding-left: 20px !important;
}

.FeatureFlagItem-module__p-l-30___Ko_69 {
  padding-left: 30px !important;
}

.FeatureFlagItem-module__p-l-40___tVnid {
  padding-left: 40px !important;
}

.FeatureFlagItem-module__p-r-16___HCKP6 {
  padding-right: 16px !important;
}

.FeatureFlagItem-module__p-r-20___TTmzc {
  padding-right: 20px !important;
}

.FeatureFlagItem-module__p-r-30___HdABI {
  padding-right: 30px !important;
}

.FeatureFlagItem-module__p-r-50___TCo9q {
  padding-right: 50px !important;
}

.FeatureFlagItem-module__p-r-60___TfjAE {
  padding-right: 60px !important;
}

.FeatureFlagItem-module__m-b-1___TNRBC {
  margin-bottom: 1px !important;
}

.FeatureFlagItem-module__m-b-2___QX5cC {
  margin-bottom: 2px !important;
}

.FeatureFlagItem-module__m-b-6___ysWR_ {
  margin-bottom: 6px !important;
}

.FeatureFlagItem-module__m-b-8___ZftY_ {
  margin-bottom: 8px !important;
}

.FeatureFlagItem-module__m-b-10___GFtVR {
  margin-bottom: 10px !important;
}

.FeatureFlagItem-module__m-b-14___ELCmh {
  margin-bottom: 14px !important;
}

.FeatureFlagItem-module__m-b-16___TeE0I {
  margin-bottom: 16px !important;
}

.FeatureFlagItem-module__m-b-20___QIeuG {
  margin-bottom: 20px !important;
}

.FeatureFlagItem-module__m-b-22___zZ0iI {
  margin-bottom: 22px !important;
}

.FeatureFlagItem-module__m-b-24___xceXz {
  margin-bottom: 24px !important;
}

.FeatureFlagItem-module__m-b-30___yLKix {
  margin-bottom: 30px !important;
}

.FeatureFlagItem-module__m-b-32___FATuo {
  margin-bottom: 32px !important;
}

.FeatureFlagItem-module__m-b-40___MBn0x {
  margin-bottom: 40px !important;
}

.FeatureFlagItem-module__m-t-2___fkTL6 {
  margin-top: 2px !important;
}

.FeatureFlagItem-module__m-t-3___JkCAQ {
  margin-top: 3px !important;
}

.FeatureFlagItem-module__m-t-4___jrtMT {
  margin-top: 4px !important;
}

.FeatureFlagItem-module__m-t-5___Ty1GW {
  margin-top: 5px !important;
}

.FeatureFlagItem-module__m-t-8___xqth3 {
  margin-top: 8px !important;
}

.FeatureFlagItem-module__m-t-10___U36rO {
  margin-top: 10px !important;
}

.FeatureFlagItem-module__m-t-15___A2Yav {
  margin-top: 15px !important;
}

.FeatureFlagItem-module__m-t-16___WKLWS {
  margin-top: 16px !important;
}

.FeatureFlagItem-module__m-t-20___JFCEg {
  margin-top: 20px !important;
}

.FeatureFlagItem-module__m-t-22___WiyoG {
  margin-top: 22px !important;
}

.FeatureFlagItem-module__m-t-30___Ju4vp {
  margin-top: 30px !important;
}

.FeatureFlagItem-module__m-t-32___xGPFV {
  margin-top: 32px !important;
}

.FeatureFlagItem-module__m-l-auto___XxClz {
  margin-left: auto !important;
}

.FeatureFlagItem-module__m-l-4___g2Izs {
  margin-left: 4px !important;
}

.FeatureFlagItem-module__m-l-5___CUi4D {
  margin-left: 5px !important;
}

.FeatureFlagItem-module__m-l-6___nd9cc {
  margin-left: 6px !important;
}

.FeatureFlagItem-module__m-l-8___CUCF5 {
  margin-left: 8px !important;
}

.FeatureFlagItem-module__m-l-10___Og7Sw {
  margin-left: 10px !important;
}

.FeatureFlagItem-module__m-l-16___XBuie {
  margin-left: 16px !important;
}

.FeatureFlagItem-module__m-l-20___fQNlB {
  margin-left: 20px !important;
}

.FeatureFlagItem-module__m-l-24___LGtb3 {
  margin-left: 24px !important;
}

.FeatureFlagItem-module__m-l-30___khAzw {
  margin-left: 30px !important;
}

.FeatureFlagItem-module__m-l-35___x_Lgz {
  margin-left: 35px !important;
}

.FeatureFlagItem-module__m-l-40___sJ0v5 {
  margin-left: 40px !important;
}

.FeatureFlagItem-module__m-r-8___CWiGy {
  margin-right: 8px !important;
}

.FeatureFlagItem-module__m-r-10___SUKUl {
  margin-right: 10px !important;
}

.FeatureFlagItem-module__m-r-16___NrMXp {
  margin-right: 16px !important;
}

.FeatureFlagItem-module__m-r-20___G4kVU {
  margin-right: 20px !important;
}

.FeatureFlagItem-module__m-r-24___rX0Xu {
  margin-right: 24px !important;
}

.FeatureFlagItem-module__m-r-30___clCAW {
  margin-right: 30px !important;
}

.FeatureFlagItem-module__m-r-40___j8n2y {
  margin-right: 40px !important;
}

.FeatureFlagItem-module__border-r-3___DNbvI {
  border-radius: 3px !important;
}

.FeatureFlagItem-module__border-r-4___svYqX {
  border-radius: 4px !important;
}

.FeatureFlagItem-module__border-r-6___If3uc {
  border-radius: 6px !important;
}

.FeatureFlagItem-module__border-r-10___kB207 {
  border-radius: 10px !important;
}

.FeatureFlagItem-module__border-r-12___FB1lx {
  border-radius: 12px !important;
}

.FeatureFlagItem-module__border-r-16___YYcCJ {
  border-radius: 16px !important;
}

.FeatureFlagItem-module__border-r-50___zRmG6 {
  border-radius: 50% !important;
}

.FeatureFlagItem-module__primary-border___vv7zm {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.FeatureFlagItem-module__primary-border-b___VBBo4 {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.FeatureFlagItem-module__primary-border-t___eXvZw {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.FeatureFlagItem-module__primary-border-l___Gflis {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.FeatureFlagItem-module__primary-border-r___yLuGP {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.FeatureFlagItem-module__secondary-border___lNXCs {
  border: 1px solid #637768;
}

.FeatureFlagItem-module__secondary-border-b___FG408 {
  border-bottom: 1px solid #637768;
}

.FeatureFlagItem-module__secondary-border-t___gnLpk {
  border-top: 1px solid #637768;
}

.FeatureFlagItem-module__secondary-border-l___YOii2 {
  border-left: 1px solid #637768;
}

.FeatureFlagItem-module__secondary-border-r___LKxIN {
  border-right: 1px solid #637768;
}

.FeatureFlagItem-module__gap-0___hdk2C {
  gap: 0 !important;
}

.FeatureFlagItem-module__gap-2___PwT1V {
  gap: 2px !important;
}

.FeatureFlagItem-module__gap-4___jUPKX {
  gap: 4px !important;
}

.FeatureFlagItem-module__gap-5___hIESF {
  gap: 5px !important;
}

.FeatureFlagItem-module__gap-6___fcOTZ {
  gap: 6px !important;
}

.FeatureFlagItem-module__gap-8___ezwtR {
  gap: 8px !important;
}

.FeatureFlagItem-module__gap-10___Md8R9 {
  gap: 10px !important;
}

.FeatureFlagItem-module__gap-12___xFgY1 {
  gap: 12px !important;
}

.FeatureFlagItem-module__gap-14___EP4VS {
  gap: 14px !important;
}

.FeatureFlagItem-module__gap-16___fnhJR {
  gap: 16px !important;
}

.FeatureFlagItem-module__gap-18___FkSnA {
  gap: 18px !important;
}

.FeatureFlagItem-module__gap-20___yHHXC {
  gap: 20px !important;
}

.FeatureFlagItem-module__gap-24___EBJjA {
  gap: 24px !important;
}

.FeatureFlagItem-module__gap-26___JRSiA {
  gap: 26px !important;
}

.FeatureFlagItem-module__gap-30___CxnDs {
  gap: 30px !important;
}

.FeatureFlagItem-module__gap-32___o93bD {
  gap: 32px !important;
}

.FeatureFlagItem-module__gap-40___SPdKc {
  gap: 40px !important;
}

.FeatureFlagItem-module__gap-50___gPoYB {
  gap: 50px !important;
}

.FeatureFlagItem-module__flex-1___C2ZcL {
  flex: 1;
}

.FeatureFlagItem-module__flex-none___NqpZl {
  flex: none !important;
}

.FeatureFlagItem-module__flex-column___wqf6P {
  display: flex;
  flex-direction: column !important;
}

.FeatureFlagItem-module__flex-row___oCRFl {
  display: flex;
  flex-direction: row !important;
}

.FeatureFlagItem-module__vertically-centered___jmJ7F {
  display: flex;
  align-items: center !important;
}

.FeatureFlagItem-module__horizontally-centered___giNfJ {
  display: flex;
  justify-content: center !important;
}

.FeatureFlagItem-module__horizontally-end___n548Z {
  display: flex;
  justify-content: end !important;
}

.FeatureFlagItem-module__vertically-start___QA4Vv {
  display: flex;
  align-items: start !important;
}

.FeatureFlagItem-module__space-between___bTm2P {
  display: flex;
  justify-content: space-between !important;
}

.FeatureFlagItem-module__flex-wrap___X9w24 {
  flex-wrap: wrap !important;
}

.FeatureFlagItem-module__height-100___zIg7J {
  height: 100%;
}

.FeatureFlagItem-module__width-50___VNxJr {
  width: 50% !important;
}

.FeatureFlagItem-module__width-100___zeers {
  width: 100%;
}

.FeatureFlagItem-module__cursor-pointer___cXUdU {
  cursor: pointer;
}

.FeatureFlagItem-module__cursor-not-allowed___b1YjM {
  cursor: not-allowed !important;
}

.FeatureFlagItem-module__absolute-centered___YhKcD {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.FeatureFlagItem-module__absolute___KuCgC {
  position: absolute;
}

.FeatureFlagItem-module__relative___WKP2X {
  position: relative;
}

.FeatureFlagItem-module__fixed___c23Xp {
  position: fixed;
}

.FeatureFlagItem-module__visible___DwzsX {
  opacity: 1;
}

.FeatureFlagItem-module__invisible___pyPoL {
  opacity: 0;
}

.FeatureFlagItem-module__col-90___bUQZH {
  width: 90% !important;
}

.FeatureFlagItem-module__col-auto___uD3Cm {
  width: auto !important;
}

.FeatureFlagItem-module__medical-tabs___vGJWy {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.FeatureFlagItem-module__medical-table-new___a0vfM {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.FeatureFlagItem-module__medical-table-new___a0vfM:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.FeatureFlagItem-module__medical-table-new___a0vfM::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.FeatureFlagItem-module__medical-table-new___a0vfM::-webkit-scrollbar-track {
  display: none;
}
.FeatureFlagItem-module__medical-table-new___a0vfM.FeatureFlagItem-module__no-pagination___F7ryg {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.FeatureFlagItem-module__medical-table-new___a0vfM.FeatureFlagItem-module__no-pagination___F7ryg:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.FeatureFlagItem-module__medical-table-new___a0vfM.FeatureFlagItem-module__no-pagination___F7ryg::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.FeatureFlagItem-module__medical-table-new___a0vfM.FeatureFlagItem-module__no-pagination___F7ryg::-webkit-scrollbar-track {
  display: none;
}

.FeatureFlagItem-module__medical-table-empty___rcnl4 {
  padding: 14px 40px !important;
}

.FeatureFlagItem-module__icon-btn___cyN5A {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.FeatureFlagItem-module__search-icon___jEPq_ {
  width: 24px;
  height: 24px;
  align-self: center;
}

.FeatureFlagItem-module__disable-select___Qhvq6 {
  user-select: none;
}

.FeatureFlagItem-module__break-word___IZdIZ {
  word-break: break-word;
}

.FeatureFlagItem-module__popup-clear-btn___Gj4OY {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.FeatureFlagItem-module__scroll-m-b-20___NAjcF {
  scroll-margin-bottom: 20px;
}

.FeatureFlagItem-module__container___MV1fg {
  margin: 0 16px 14px 16px;
}
.FeatureFlagItem-module__container___MV1fg .FeatureFlagItem-module__wrapper___eu7w0 {
  color: #375844;
}
.FeatureFlagItem-module__container___MV1fg .FeatureFlagItem-module__wrapper___eu7w0 .FeatureFlagItem-module__dash___OCYal {
  margin: 0 5px;
}

.FeatureFlagItem-module__button___sppfT {
  width: 180px;
  padding: 6px;
  box-sizing: border-box;
}
.FeatureFlagItem-module__button___sppfT .FeatureFlagItem-module__point___HOQpa {
  width: 9px;
  height: 9px;
  border-radius: 50%;
  margin-right: 10px;
  display: inline-block;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/components/screens/FeatureFlagsScreen/FeatureFlagItem/FeatureFlagItem.module.scss","webpack://./../common/src/styles/global/_mixins.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,wBAAA;AA8pBF;AA5pBE;EACE,cAAA;AA8pBJ;AA5pBI;EACE,aAAA;AA8pBN;;AAzpBA;EACE,YAAA;EACA,YAAA;EACA,sBAAA;AA4pBF;AA1pBE;EACE,UAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,qBAAA;AA4pBJ","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.container {\n  margin: 0 16px 14px 16px;\n\n  .wrapper {\n    color: get-color(greenNew, dark);\n\n    .dash {\n      margin: 0 5px;\n    }\n  }\n}\n\n.button {\n  width: 180px;\n  padding: 6px;\n  box-sizing: border-box;\n\n  .point {\n    width: 9px;\n    height: 9px;\n    border-radius: 50%;\n    margin-right: 10px;\n    display: inline-block;\n  }\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `FeatureFlagItem-module__font-s-10___lXWq5`,
	"fontS12": `FeatureFlagItem-module__font-s-12___ARyJV`,
	"fontS13": `FeatureFlagItem-module__font-s-13___jcawV`,
	"fontS14": `FeatureFlagItem-module__font-s-14___wXrMc`,
	"fontS15": `FeatureFlagItem-module__font-s-15___NN5Gi`,
	"fontS16": `FeatureFlagItem-module__font-s-16___DqF2L`,
	"fontS18": `FeatureFlagItem-module__font-s-18___UL4KT`,
	"fontS20": `FeatureFlagItem-module__font-s-20___pdS4v`,
	"fontS22": `FeatureFlagItem-module__font-s-22___Fog9s`,
	"fontS28": `FeatureFlagItem-module__font-s-28___Mr_CP`,
	"fontW400": `FeatureFlagItem-module__font-w-400___RSaQU`,
	"fontW500": `FeatureFlagItem-module__font-w-500___zsiSW`,
	"fontW600": `FeatureFlagItem-module__font-w-600___bXqoP`,
	"fontW700": `FeatureFlagItem-module__font-w-700___h5xEz`,
	"p5": `FeatureFlagItem-module__p-5___kWruT`,
	"p12": `FeatureFlagItem-module__p-12___Ed_mg`,
	"p16": `FeatureFlagItem-module__p-16___feXoY`,
	"p30": `FeatureFlagItem-module__p-30___LGcwl`,
	"pB0": `FeatureFlagItem-module__p-b-0___ACpq9`,
	"pB5": `FeatureFlagItem-module__p-b-5___lo5hJ`,
	"pB10": `FeatureFlagItem-module__p-b-10___bkSR4`,
	"pB12": `FeatureFlagItem-module__p-b-12___qMZed`,
	"pB16": `FeatureFlagItem-module__p-b-16___Jx1N1`,
	"pB18": `FeatureFlagItem-module__p-b-18___fxUGS`,
	"pB20": `FeatureFlagItem-module__p-b-20___otmO2`,
	"pB25": `FeatureFlagItem-module__p-b-25___Hkdyt`,
	"pB30": `FeatureFlagItem-module__p-b-30___LzaiC`,
	"pB50": `FeatureFlagItem-module__p-b-50___ZMO5_`,
	"pT0": `FeatureFlagItem-module__p-t-0___cS3H7`,
	"pT12": `FeatureFlagItem-module__p-t-12___L_2hx`,
	"pT16": `FeatureFlagItem-module__p-t-16___OiGKU`,
	"pT18": `FeatureFlagItem-module__p-t-18___PWO4H`,
	"pT20": `FeatureFlagItem-module__p-t-20___G7gYW`,
	"pT30": `FeatureFlagItem-module__p-t-30___XvgQo`,
	"pT40": `FeatureFlagItem-module__p-t-40___HaBRy`,
	"pT50": `FeatureFlagItem-module__p-t-50____wZzS`,
	"pL20": `FeatureFlagItem-module__p-l-20___mVMQ4`,
	"pL30": `FeatureFlagItem-module__p-l-30___Ko_69`,
	"pL40": `FeatureFlagItem-module__p-l-40___tVnid`,
	"pR16": `FeatureFlagItem-module__p-r-16___HCKP6`,
	"pR20": `FeatureFlagItem-module__p-r-20___TTmzc`,
	"pR30": `FeatureFlagItem-module__p-r-30___HdABI`,
	"pR50": `FeatureFlagItem-module__p-r-50___TCo9q`,
	"pR60": `FeatureFlagItem-module__p-r-60___TfjAE`,
	"mB1": `FeatureFlagItem-module__m-b-1___TNRBC`,
	"mB2": `FeatureFlagItem-module__m-b-2___QX5cC`,
	"mB6": `FeatureFlagItem-module__m-b-6___ysWR_`,
	"mB8": `FeatureFlagItem-module__m-b-8___ZftY_`,
	"mB10": `FeatureFlagItem-module__m-b-10___GFtVR`,
	"mB14": `FeatureFlagItem-module__m-b-14___ELCmh`,
	"mB16": `FeatureFlagItem-module__m-b-16___TeE0I`,
	"mB20": `FeatureFlagItem-module__m-b-20___QIeuG`,
	"mB22": `FeatureFlagItem-module__m-b-22___zZ0iI`,
	"mB24": `FeatureFlagItem-module__m-b-24___xceXz`,
	"mB30": `FeatureFlagItem-module__m-b-30___yLKix`,
	"mB32": `FeatureFlagItem-module__m-b-32___FATuo`,
	"mB40": `FeatureFlagItem-module__m-b-40___MBn0x`,
	"mT2": `FeatureFlagItem-module__m-t-2___fkTL6`,
	"mT3": `FeatureFlagItem-module__m-t-3___JkCAQ`,
	"mT4": `FeatureFlagItem-module__m-t-4___jrtMT`,
	"mT5": `FeatureFlagItem-module__m-t-5___Ty1GW`,
	"mT8": `FeatureFlagItem-module__m-t-8___xqth3`,
	"mT10": `FeatureFlagItem-module__m-t-10___U36rO`,
	"mT15": `FeatureFlagItem-module__m-t-15___A2Yav`,
	"mT16": `FeatureFlagItem-module__m-t-16___WKLWS`,
	"mT20": `FeatureFlagItem-module__m-t-20___JFCEg`,
	"mT22": `FeatureFlagItem-module__m-t-22___WiyoG`,
	"mT30": `FeatureFlagItem-module__m-t-30___Ju4vp`,
	"mT32": `FeatureFlagItem-module__m-t-32___xGPFV`,
	"mLAuto": `FeatureFlagItem-module__m-l-auto___XxClz`,
	"mL4": `FeatureFlagItem-module__m-l-4___g2Izs`,
	"mL5": `FeatureFlagItem-module__m-l-5___CUi4D`,
	"mL6": `FeatureFlagItem-module__m-l-6___nd9cc`,
	"mL8": `FeatureFlagItem-module__m-l-8___CUCF5`,
	"mL10": `FeatureFlagItem-module__m-l-10___Og7Sw`,
	"mL16": `FeatureFlagItem-module__m-l-16___XBuie`,
	"mL20": `FeatureFlagItem-module__m-l-20___fQNlB`,
	"mL24": `FeatureFlagItem-module__m-l-24___LGtb3`,
	"mL30": `FeatureFlagItem-module__m-l-30___khAzw`,
	"mL35": `FeatureFlagItem-module__m-l-35___x_Lgz`,
	"mL40": `FeatureFlagItem-module__m-l-40___sJ0v5`,
	"mR8": `FeatureFlagItem-module__m-r-8___CWiGy`,
	"mR10": `FeatureFlagItem-module__m-r-10___SUKUl`,
	"mR16": `FeatureFlagItem-module__m-r-16___NrMXp`,
	"mR20": `FeatureFlagItem-module__m-r-20___G4kVU`,
	"mR24": `FeatureFlagItem-module__m-r-24___rX0Xu`,
	"mR30": `FeatureFlagItem-module__m-r-30___clCAW`,
	"mR40": `FeatureFlagItem-module__m-r-40___j8n2y`,
	"borderR3": `FeatureFlagItem-module__border-r-3___DNbvI`,
	"borderR4": `FeatureFlagItem-module__border-r-4___svYqX`,
	"borderR6": `FeatureFlagItem-module__border-r-6___If3uc`,
	"borderR10": `FeatureFlagItem-module__border-r-10___kB207`,
	"borderR12": `FeatureFlagItem-module__border-r-12___FB1lx`,
	"borderR16": `FeatureFlagItem-module__border-r-16___YYcCJ`,
	"borderR50": `FeatureFlagItem-module__border-r-50___zRmG6`,
	"primaryBorder": `FeatureFlagItem-module__primary-border___vv7zm`,
	"primaryBorderB": `FeatureFlagItem-module__primary-border-b___VBBo4`,
	"primaryBorderT": `FeatureFlagItem-module__primary-border-t___eXvZw`,
	"primaryBorderL": `FeatureFlagItem-module__primary-border-l___Gflis`,
	"primaryBorderR": `FeatureFlagItem-module__primary-border-r___yLuGP`,
	"secondaryBorder": `FeatureFlagItem-module__secondary-border___lNXCs`,
	"secondaryBorderB": `FeatureFlagItem-module__secondary-border-b___FG408`,
	"secondaryBorderT": `FeatureFlagItem-module__secondary-border-t___gnLpk`,
	"secondaryBorderL": `FeatureFlagItem-module__secondary-border-l___YOii2`,
	"secondaryBorderR": `FeatureFlagItem-module__secondary-border-r___LKxIN`,
	"gap0": `FeatureFlagItem-module__gap-0___hdk2C`,
	"gap2": `FeatureFlagItem-module__gap-2___PwT1V`,
	"gap4": `FeatureFlagItem-module__gap-4___jUPKX`,
	"gap5": `FeatureFlagItem-module__gap-5___hIESF`,
	"gap6": `FeatureFlagItem-module__gap-6___fcOTZ`,
	"gap8": `FeatureFlagItem-module__gap-8___ezwtR`,
	"gap10": `FeatureFlagItem-module__gap-10___Md8R9`,
	"gap12": `FeatureFlagItem-module__gap-12___xFgY1`,
	"gap14": `FeatureFlagItem-module__gap-14___EP4VS`,
	"gap16": `FeatureFlagItem-module__gap-16___fnhJR`,
	"gap18": `FeatureFlagItem-module__gap-18___FkSnA`,
	"gap20": `FeatureFlagItem-module__gap-20___yHHXC`,
	"gap24": `FeatureFlagItem-module__gap-24___EBJjA`,
	"gap26": `FeatureFlagItem-module__gap-26___JRSiA`,
	"gap30": `FeatureFlagItem-module__gap-30___CxnDs`,
	"gap32": `FeatureFlagItem-module__gap-32___o93bD`,
	"gap40": `FeatureFlagItem-module__gap-40___SPdKc`,
	"gap50": `FeatureFlagItem-module__gap-50___gPoYB`,
	"flex1": `FeatureFlagItem-module__flex-1___C2ZcL`,
	"flexNone": `FeatureFlagItem-module__flex-none___NqpZl`,
	"flexColumn": `FeatureFlagItem-module__flex-column___wqf6P`,
	"flexRow": `FeatureFlagItem-module__flex-row___oCRFl`,
	"verticallyCentered": `FeatureFlagItem-module__vertically-centered___jmJ7F`,
	"horizontallyCentered": `FeatureFlagItem-module__horizontally-centered___giNfJ`,
	"horizontallyEnd": `FeatureFlagItem-module__horizontally-end___n548Z`,
	"verticallyStart": `FeatureFlagItem-module__vertically-start___QA4Vv`,
	"spaceBetween": `FeatureFlagItem-module__space-between___bTm2P`,
	"flexWrap": `FeatureFlagItem-module__flex-wrap___X9w24`,
	"height100": `FeatureFlagItem-module__height-100___zIg7J`,
	"width50": `FeatureFlagItem-module__width-50___VNxJr`,
	"width100": `FeatureFlagItem-module__width-100___zeers`,
	"cursorPointer": `FeatureFlagItem-module__cursor-pointer___cXUdU`,
	"cursorNotAllowed": `FeatureFlagItem-module__cursor-not-allowed___b1YjM`,
	"absoluteCentered": `FeatureFlagItem-module__absolute-centered___YhKcD`,
	"absolute": `FeatureFlagItem-module__absolute___KuCgC`,
	"relative": `FeatureFlagItem-module__relative___WKP2X`,
	"fixed": `FeatureFlagItem-module__fixed___c23Xp`,
	"visible": `FeatureFlagItem-module__visible___DwzsX`,
	"invisible": `FeatureFlagItem-module__invisible___pyPoL`,
	"col90": `FeatureFlagItem-module__col-90___bUQZH`,
	"colAuto": `FeatureFlagItem-module__col-auto___uD3Cm`,
	"medicalTabs": `FeatureFlagItem-module__medical-tabs___vGJWy`,
	"medicalTableNew": `FeatureFlagItem-module__medical-table-new___a0vfM`,
	"noPagination": `FeatureFlagItem-module__no-pagination___F7ryg`,
	"medicalTableEmpty": `FeatureFlagItem-module__medical-table-empty___rcnl4`,
	"iconBtn": `FeatureFlagItem-module__icon-btn___cyN5A`,
	"searchIcon": `FeatureFlagItem-module__search-icon___jEPq_`,
	"disableSelect": `FeatureFlagItem-module__disable-select___Qhvq6`,
	"breakWord": `FeatureFlagItem-module__break-word___IZdIZ`,
	"popupClearBtn": `FeatureFlagItem-module__popup-clear-btn___Gj4OY`,
	"scrollMB20": `FeatureFlagItem-module__scroll-m-b-20___NAjcF`,
	"container": `FeatureFlagItem-module__container___MV1fg`,
	"wrapper": `FeatureFlagItem-module__wrapper___eu7w0`,
	"dash": `FeatureFlagItem-module__dash___OCYal`,
	"button": `FeatureFlagItem-module__button___sppfT`,
	"point": `FeatureFlagItem-module__point___HOQpa`
};
module.exports = ___CSS_LOADER_EXPORT___;
